import createConsoleArgs from './createConsoleArgs';
import createLogject from './createLogject';
import { isLevelActive } from './levels';
const levelLog = (config) => {
    const { level, logToConsole, scribe, targetLevel, scribeTargetLevel } = config;
    if (!isLevelActive(level.name, targetLevel)) {
        return;
    }
    const method = level.consoleMethod;
    const logJect = createLogject(config, config.args);
    if (logToConsole) {
        console[method](...createConsoleArgs(logJect));
    }
    if (scribe && isLevelActive(level.name, scribeTargetLevel)) {
        scribe.log(logJect);
    }
};
export default levelLog;
//# sourceMappingURL=levelLog.js.map